<template>
	<div :style="{direction: $vs.rtl ? 'rtl' : 'ltr'}">
		<feather-icon
			icon="EditIcon"
			svgClasses="h-5 w-5 mr-2 hover:text-primary cursor-pointer"
			:title="$t('Edit')"
			@click="editRecord"
		/>
		<feather-icon
			v-if="capacityDeletePermission"
			icon="Trash2Icon"
			svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
			:title="$t('Crud.Delete')"
			@click="confirmDeleteRecord"
		/>
	</div>
</template>

<script>
import moduleCapacity from "@/store/capacity/moduleCapacity.js";

export default {
	name: "CellRendererActions",
	data() {
		return {
			capacityListCopy: [],
			isRemove: true,
			timeoutCount: null,
			loading: true,
			percent: 0,
		};
	},
	computed: {
		capacityDeletePermission() {
			return this.$store.getters.checkPermission("CAPACITY_D");
		},
		dataCapacity() {
			return this.$store.state.moduleCapacity.capabilities;
		},
	},
	methods: {
		editRecord() {
			this.$router.push("/dashboard/update-capacity/" + this.params.data.id).catch(() => {});
		},
		confirmUndo() {
			this.capacityListCopy = [...this.dataCapacity];
			this.$store.commit("moduleCapacity/ADD_ID_CAPACITY", this.params.data.id);
			this.$store.commit("moduleCapacity/REMOVE_CAPACITY", this.params.data.id);
			this.$vs.notify({
				title: `${this.$t(
					"Capacity.Messages.TitleConfirmDelete"
				)} <a id="undoOperation" class="button-undo">${this.$t("Undo")}</a>`,
				text: `"${this.params.data.name}"`,
				color: "success",
				time: 10000,
			});
			let notifyActive = document.querySelector(".vs-notifications .content-noti .con-text-noti");
			notifyActive.insertAdjacentHTML(
				"beforeend",
				`
				<div
					class="vs-progress--background vs-progress-primary indeterminate" style="background: white; height: 6px;"
				>
					<div class="vs-progress--foreground" style="width: 0%;"></div>
					<div class="vs-progress--indeterminate" style="width: 0%;"></div>
				</div>`
			);
			document.getElementById("undoOperation").addEventListener("click", () => {
				this.isRemove = false;
				this.$store.commit("moduleCapacity/REMOVE_ID_CAPACITY", this.params.data.id);
				this.$store.commit("moduleCapacity/SET_CAPACITY", []);
				this.$store.commit("moduleCapacity/SET_CAPACITY", this.capacityListCopy);
			});
			this.timeoutCount = setTimeout(() => {
				if (this.isRemove) {
					this.deleteRecord();
				}
			}, 10000);
		},
		confirmDeleteRecord() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text:
					this.$t("Capacity.DeleteCapacity.Text1") +
					` "${this.params.data.name}"? ` +
					this.$t("Capacity.DeleteCapacity.Text2"),
				accept: this.confirmUndo,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteRecord() {
			this.$store
				.dispatch("moduleCapacity/deleteById", this.params.data.id)
				.then((res) => {
					clearTimeout(this.timeoutCount);
					this.$store.commit("moduleCapacity/REMOVE_ID_CAPACITY", this.params.data.id);
					return res;
				})
				.catch((err) => {
					if (err.response.status === 404) {
						return;
					}
					console.error(err);
					clearTimeout(this.timeoutCount);
				});
		},
	},
	created() {
		if (!moduleCapacity.isRegistered) {
			this.$store.registerModule("moduleCapacity", moduleCapacity);
			moduleCapacity.isRegistered = true;
		}
	},
};
</script>
<style lang="scss">
.button-undo {
	border-bottom: 2px solid;
	color: rgb(92, 91, 91);
	margin-left: 5px;
	font-weight: bold;
	cursor: pointer;
	font-size: 14px;
}
</style>
